import { get, remove, set } from "./Preferences";

const _requestedURLKey = "RequestedURL";

export const setRequestedURL = async (pathname: string) => {
    if (!!!pathname) {
        pathname = window.location.pathname;
    }
    if (pathname.includes("://")) {
        try {
            const urlObj = new URL(pathname);
            pathname = urlObj.pathname + (urlObj.search || "");
        } catch {
            // not a valid URL — use as-is
        }
    }
    if (!pathname.includes("/logout")) {
        await set(_requestedURLKey, pathname);
    }
};

export const getRequestedURL = async () => {
    //get stored URL
    let pathname = await get(_requestedURLKey);
    if (!!pathname) {
        //clear requested url
        remove(_requestedURLKey);

        return pathname;
    }
    return "/home";
};

const getRoutePath = (path: string) => {
    if (!!path) {
        const urlObj = new URL(path);
        return `${urlObj.pathname}/${urlObj.search}`;
    }
    return path;
};

/**
 * Strips trailing "/" characters.
 *
 * Deliberately index-based instead of `value.replace(/\/+$/, "")`: an unanchored
 * `\/+$` is re-attempted at every position of the input, so a long run of
 * slashes costs O(n^2) backtracking (flagged as a ReDoS hotspot by static
 * analysis). This scan is linear and never backtracks.
 */
export const trimTrailingSlashes = (value: string): string => {
    let end = value.length;
    while (end > 0 && value.charAt(end - 1) === "/") {
        end--;
    }
    return end === value.length ? value : value.substring(0, end);
};

/**
 * Strips leading and trailing "/" characters — the regex-free equivalent of
 * `value.replace(/^\/+|\/+$/g, "")`. See {@link trimTrailingSlashes}.
 */
export const trimSlashes = (value: string): string => {
    let start = 0;
    const trimmed = trimTrailingSlashes(value);
    while (start < trimmed.length && trimmed.charAt(start) === "/") {
        start++;
    }
    return start === 0 ? trimmed : trimmed.substring(start);
};
